export default class EmailCampaignRecipient {
	id!: number;
	recipientType!: 'teacher' | 'secretary' | 'student';
	recipientName!: string;
	recipientEmail!: string;
	districtId?: number;
	districtName!: string;
	isManualAddition!: boolean;
	emailSentAt?: Date;
	linkClickedAt?: Date;
	passwordVerifiedAt?: Date;
	codeEnteredAt?: Date;
	codeEnteredValue?: string;
	codeIsValid?: boolean;
	adminComment?: string;
	verificationCode?: string; // tylko dla admina
	emailError?: string;

	static fromApiResponse(data: any): EmailCampaignRecipient {
		const recipient = new EmailCampaignRecipient();
		recipient.id = data.id;
		recipient.recipientType = data.recipient_type;
		recipient.recipientName = data.recipient_name;
		recipient.recipientEmail = data.recipient_email;
		recipient.districtId = data.district_id;
		recipient.districtName = data.district_name;
		recipient.isManualAddition = data.is_manual_addition;
		recipient.emailSentAt = data.email_sent_at ? new Date(data.email_sent_at) : undefined;
		recipient.linkClickedAt = data.link_clicked_at ? new Date(data.link_clicked_at) : undefined;
		recipient.passwordVerifiedAt = data.password_verified_at ? new Date(data.password_verified_at) : undefined;
		recipient.codeEnteredAt = data.code_entered_at ? new Date(data.code_entered_at) : undefined;
		recipient.codeEnteredValue = data.code_entered_value;
		recipient.codeIsValid = data.code_is_valid;
		recipient.adminComment = data.admin_comment;
		recipient.verificationCode = data.verification_code;
		recipient.emailError = data.email_error;
		return recipient;
	}
}
